// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { ContoEconomicoAnnoPrecedenteDto } from '@ideapa/common-dto';

import { map, Observable } from 'rxjs';
import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class ContoEconomicoAnnoPrecedenteApiClient extends BaseCRUDApiClient<ContoEconomicoAnnoPrecedenteDto> {
  baseUrl = this.config.apiEndpoint + '/conto-economico-anno-precedente';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  estraiCEAnnoPrecedente() {
    return this.http.get<ContoEconomicoAnnoPrecedenteDto[]>(
      this.baseUrl + '/estrai-ce-anno-precedente'
    );
  }

  donwloadCEAnnoPrecedenteCep(fileName: string): Observable<ArrayBuffer> {
    return this.http
      .post(
        this.baseUrl + '/download-ce-anno-precedente',
        {
          fileName: fileName,
        },
        {
          responseType: 'arraybuffer',
        }
      )
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        })
      );
  }

  updateRigaCE(idRiga: number, importoAP: number) {
    return this.http.post<ContoEconomicoAnnoPrecedenteDto[]>(
      this.baseUrl + '/update-riga-ce-anno-precedente',
      {
        idRiga: idRiga,
        importoAP: importoAP,
      }
    );
  }
}
